<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.childcareRate.maleAcquisitionCount.$invalid
      || $v.childcareRate.femaleAcquisitionCount.$invalid 
      || $v.childcareRate.maleTargetCount.$invalid
      || $v.childcareRate.femaleTargetCount.$invalid
      || $v.childcareRate.resultMemo.$invalid 
      || $v.childcareRate.actionMemo.$invalid">

      <div v-if="$v.childcareRate.maleAcquisitionCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">育児休業取得者数（男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.maleAcquisitionCount.$invalid && !$v.childcareRate.maleAcquisitionCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.maleAcquisitionCount.$invalid && $v.childcareRate.maleAcquisitionCount.numeric && !$v.childcareRate.maleAcquisitionCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.childcareRate.femaleAcquisitionCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">育児休業取得者数（女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.femaleAcquisitionCount.$invalid && !$v.childcareRate.femaleAcquisitionCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.femaleAcquisitionCount.$invalid && $v.childcareRate.femaleAcquisitionCount.numeric && !$v.childcareRate.femaleAcquisitionCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.childcareRate.maleTargetCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">育児休業対象者数（男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.maleTargetCount.$invalid && !$v.childcareRate.maleTargetCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.maleTargetCount.$invalid && $v.childcareRate.maleTargetCount.numeric && !$v.childcareRate.maleTargetCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.childcareRate.femaleTargetCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">育児休業対象者数（女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.femaleTargetCount.$invalid && !$v.childcareRate.femaleTargetCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.childcareRate.femaleTargetCount.$invalid && $v.childcareRate.femaleTargetCount.numeric && !$v.childcareRate.femaleTargetCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.childcareRate.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.childcareRate.resultMemo.$invalid && !$v.childcareRate.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.childcareRate.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.childcareRate.actionMemo.$invalid && !$v.childcareRate.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">育児休業取得者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>取得者</th>
              <th>対象者</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.childcareRate.$model.maleAcquisitionCount" type="text" name="childcareRate.maleAcquisitionCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.childcareRate.$model.maleTargetCount" type="text" name="childcareRate.maleTargetCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.childcareRate.$model.femaleAcquisitionCount" type="text" name="childcareRate.femaleAcquisitionCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.childcareRate.$model.femaleTargetCount" type="text" name="childcareRate.femaleTargetCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAcquisitionCount" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfTargetCount" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">育児休業取得率</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>取得率</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementMaleChildcareRate" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr>
              <th>女性</th>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementFemaleChildcareRate" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementAllChildcareRate" :unit="this.unit2"/></strong></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="childcareRate.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(childcareRate.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="childcareRate.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    childcareRate: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    sumOfAcquisitionCount() {
      if ( !(this.childcareRate.maleAcquisitionCount!=null && this.childcareRate.femaleAcquisitionCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleAcquisitionCount).length * String(this.childcareRate.femaleAcquisitionCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleAcquisitionCount) || isNaN(this.childcareRate.femaleAcquisitionCount)) {
        return null;
      }else{
        return Number(this.childcareRate.maleAcquisitionCount) + Number(this.childcareRate.femaleAcquisitionCount);
      }
    },
    sumOfTargetCount() {
      if ( !(this.childcareRate.maleTargetCount!=null && this.childcareRate.femaleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleTargetCount).length * String(this.childcareRate.femaleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleTargetCount) || isNaN(this.childcareRate.femaleTargetCount)) {
        return null;
      }else{
        return Number(this.childcareRate.maleTargetCount) + Number(this.childcareRate.femaleTargetCount);
      }
    },
    calcAchievementMaleChildcareRate() {
      if ( !(this.childcareRate.maleAcquisitionCount!=null && this.childcareRate.maleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleAcquisitionCount).length * String(this.childcareRate.maleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleAcquisitionCount) || isNaN(this.childcareRate.maleTargetCount)) {
        return null;
      }else{
        if ( this.childcareRate.maleTargetCount == 0 ) return null;
        if ( this.childcareRate.maleAcquisitionCount == 0 ) return 0;
        let val = (this.childcareRate.maleAcquisitionCount / this.childcareRate.maleTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    calcAchievementFemaleChildcareRate() {
      if ( !(this.childcareRate.femaleAcquisitionCount!=null && this.childcareRate.femaleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.femaleAcquisitionCount).length * String(this.childcareRate.femaleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.femaleAcquisitionCount) || isNaN(this.childcareRate.femaleTargetCount)) {
        return null;
      }else{
        if ( this.childcareRate.femaleTargetCount == 0 ) return null;
        if ( this.childcareRate.femaleAcquisitionCount == 0 ) return 0;
        let val = (this.childcareRate.femaleAcquisitionCount / this.childcareRate.femaleTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    calcAchievementAllChildcareRate() {
      if ( this.sumOfAcquisitionCount != null && this.sumOfTargetCount != null ){
        if ( this.sumOfTargetCount == 0 ) return null;
        if ( this.sumOfAcquisitionCount == 0 ) return 0;
        let val = (this.sumOfAcquisitionCount / this.sumOfTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    },
  },
  validations: {
    childcareRate: {
      maleAcquisitionCount : { numeric, between: between(0,99999) },         // 売上（実績）
      femaleAcquisitionCount : { numeric, between: between(0,99999) },         // 売上（実績）
      maleTargetCount : { numeric, between: between(0,99999) },         // 売上（実績）
      femaleTargetCount : { numeric, between: between(0,99999) },         // 売上（実績）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    childcareRate() {
      this.inputChildcareRate();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputChildcareRate() {
      this.$emit("change-female-percentage", {
        childcareRate: this.childcareRate,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
